import React, { FC } from 'react'

import { EStatus, TStatus } from 'common/types'

import { Tag } from '@interco/inter-ui/components/Tag'
import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import { useServiceButton } from '../hooks/useServiceButton'
import { ServiceButtonView } from './ServiceButtonView'
import { TServiceButton } from '../types/ServiceButton.types'
import { TagContainer } from '../styles/ServiceButton.styles'

export const ServiceButton: FC<TServiceButton> = ({
  icon,
  title,
  details,
  route,
  status = EStatus.OPEN.toUpperCase() as TStatus,
  info,
}) => {
  const serviceButton = useServiceButton({
    details,
    icon,
    route,
    title,
    status,
    info,
  })

  const content = serviceButton?.content

  if (!content) return <Skeleton height="4.08rem" width="23.375rem" />

  const { tagStatus, theme, hasUpdate } = content

  return (
    <ServiceButtonView
      hasUpdate={hasUpdate}
      title={content.title}
      icon={content.icon}
      navigateTo={content.navigateTo}
    >
      <TagContainer>
        <Tag theme={theme} intensity="light" size="small">
          {tagStatus}
        </Tag>
      </TagContainer>
    </ServiceButtonView>
  )
}
